// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : REMOVED UNUSED REDUCERS
// MODIFIED DATE: 26-09-2025

import repaymentCollectionReportTypes from './repayment-collection-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// FETCH POST REPAYMENT COLLECTION RESPONSE
	fetchPostRepaymentCollectionResponse: null,
	fetchPostRepaymentCollectionArr: [],
};

const repaymentCollectionReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/************* FETCH REPAYMENT COLLECTION REPORT START *********************** */
		case repaymentCollectionReportTypes.FETCH_POST_REPAYMENT_COLLECTION_SUCCESS:
			return {
				...state,
				fetchPostRepaymentCollectionResponse: action.payload,
				fetchPostRepaymentCollectionArr: docodeHexResponse(
					action.payload,
					'RepaymentCollectionListKey',
				),
			};

		case repaymentCollectionReportTypes.FETCH_POST_REPAYMENT_COLLECTION_FAILURE:
			return {
				...state,
				fetchPostRepaymentCollectionResponse: null,
				fetchPostRepaymentCollectionArr: action.payload,
			};

		case repaymentCollectionReportTypes.FETCH_POST_REPAYMENT_COLLECTION_RESPONSE_CHANGED:
			return {
				...state,
				fetchPostRepaymentCollectionResponse: null,
			};
		/************* FETCH REPAYMENT COLLECTION REPORT END *********************** */
		default:
			return state;
	}
};

export default repaymentCollectionReportReducer;
